export const FEATURE_PERMISSION_VISIBILITY = [
    {
      featureKey: "navigator",
      enabledSelector: (s: any) => s.enableNavigator,
      permissionTitles: ["Can Access Navigator"],
    },
    {
      featureKey: "categoryAnalysis",
      enabledSelector: (s: any) => s.enableCategoryAnalysis,
      permissionTitles: ["Can Access Category Analysis"],
    },
    {
      featureKey: "productAnalysis",
      enabledSelector: (s: any) => s.enableProductAnalysis,
      permissionTitles: ["Can Access Product Analysis"],
    },
] as const;
  